import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Modal,
  ModalBody,
  Container
} from 'reactstrap';
import CloseIcon from "../../images/close-button-search.png"
import { Button } from '../Forms';
import propTypes from 'prop-types';

const CloseButton = props =>(
  <div className="closeIcon" style={{textAlign: 'right'}}>
    <KickImage src={CloseIcon} onClick={props.onClick} style={{width: '15px'}}/>
  </div>
)

const ModalOutOfStock = props => (
  <Modal isOpen={props.isOpen} toggle={props.onToggle} modalClassName="modal__welcome__new">
    <ModalBody>
      <Container>
        { props.isCloseable? <CloseButton onClick={props.onToggle}/>: null }
        <p style={{textAlign: 'center'}}>{props.message}</p>
        <Button className="btn-green" onClick={props.onButtonPrimaryClick}>
          {props.buttonPrimaryText}
        </Button>
      </Container>
    </ModalBody>
  </Modal>
)

export default ModalOutOfStock;

ModalOutOfStock.defaultProps ={
  isCloseable: false,
  isOpen: false,
  message: "Hello, this is message.",
  buttonPrimaryText: "OK"
}

ModalOutOfStock.propTypes = {
  isCloseable: propTypes.bool,
  isOpen: propTypes.bool,
  message: propTypes.string,
  buttonPrimaryText: propTypes.string,
  onButtonPrimaryClick: propTypes.func,
  onToggle: propTypes.func
}